export const validTimeValueFormat = value => value.match(/^\d\d:\d\d$/)

export const halfHourTimeOptions = Array.from({ length: 48 }, (_value, index) => {
  const hours = Math.floor(index / 2).toString().padStart(2, '0')
  const minutes = index % 2 === 0 ? '00' : '30'

  return `${hours}:${minutes}`
})

export const validActiveWindow = window => (
  halfHourTimeOptions.includes(window.get('from'))
  && halfHourTimeOptions.includes(window.get('to'))
  && window.get('from') < window.get('to')
)

export const filterTimeValues = values => values.filter(value => {
  if (!validTimeValueFormat(value)) {
    return false
  }

  const [hours, minutes] = value.split(':').map(part => parseInt(part, 10))

  return hours <= 23 && hours >= 0 && minutes <= 59 && minutes >= 0
})
